import { Divider, ListItemText, MenuItem, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import AppointmentCard from "../../../components/CardVisit/AppointmentCard";
import { GvCustomMenu } from "../../../styles/styledComponents";
import HealthRecordsEmpty from "../HealthRecordsContainer/HealthRecordsEmpty";
import { IAppointmentDetails } from "../../../services/appointment-list/appointment-list.interface";
import { IPetItemResponse } from "../../../services/Standard-of-care/standard-of-care.interface";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getLastNYears } from "../../../utils/genericUtils";

type IPastAppointmentProps = {
    pastAppointments: IAppointmentDetails[];
    petData: IPetItemResponse;
}

const PastVisitsContainer = (props: IPastAppointmentProps) => {
  const { pastAppointments, petData } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
  const [filteredAppointments, setFilteredAppointments] = useState<IAppointmentDetails[]>([]);

  const handleYearChange = (value: number) => {
    setSelectedYear(value);
    handleClose();
  };

  const yearsList = getLastNYears(5);

  useEffect(()=>{
    if (pastAppointments && pastAppointments.length) {
      const filteredAppointments = pastAppointments.filter((appointment) =>
        new Date(appointment.dateTime).getFullYear() === selectedYear);

      setFilteredAppointments(filteredAppointments);
    }
  }, [selectedYear, pastAppointments]);


  return (
    <div className="flex flex-col gap-3 h-full">
      {pastAppointments.length ?
        <div className="flex justify-between">
          <Typography variant="h4" className="font-semibold">Past Visits</Typography>

          <div className="flex gap-1 border border-gray-3 rounded-lg min-w-min items-center px-2 bg-white
        cursor-pointer" id="appointment-button" aria-haspopup="true"
          aria-controls={open ? "appointment-menu" : undefined}
          aria-expanded={open ? "true" : undefined} onClick={(e)=>handleClick(e)}>
            <Typography variant="body1"> {selectedYear} </Typography>
            <KeyboardArrowDownIcon/>
          </div>

          <GvCustomMenu autoFocus={false} transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            id="appointment-menu" anchorEl={anchorEl} open={open}
            onClose={handleClose}
            MenuListProps={{ "aria-labelledby": "appointment-button" }}>
            {yearsList.map((year) => (
              <div key={year}>
                <MenuItem onClick={()=>handleYearChange(year)}>
                  <ListItemText>{year}</ListItemText>
                </MenuItem>
                <Divider className="w-full !m-0" />
              </div>
            ))}
          </GvCustomMenu>
        </div> : null }
      <div className="h-full">

        {pastAppointments.length && filteredAppointments.length ?
          filteredAppointments.map((visit, index) => (
            <AppointmentCard
              key={index}
              visit={visit}
              isReviewCard={visit.feedback.length === 4}
            />
          )) :
          <HealthRecordsEmpty petData={petData} referredFrom="past_visits" />
        }
      </div>
    </div>
  );
};

export default PastVisitsContainer;
